

import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {format} from 'one-util-date';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    TransformBillingDetails
} from './transform';

import {
    setAction as setBillingAction,
    selectAction as selectBillingAction,
    addAction as addBillingAction,
    BillingIdentifier,
    resetAction
} from 'one-state-billing-identifier';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import { Disposition } from 'one-model-local';

export const enum Types {
    SETBILLING = 'set-billing/set',
    ADDBILLINGSET = 'one-state-billing-details/add',
    BILLINGDETAILS = 'one-state-billing-details/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
    FETCHGUARANTORDETAILS = 'one-state-billing-details/fetch',
    SELECTEDBILLINGREQUEST = 'one-state-billing-details/request'
}

const setBilling = (payload: any) => ({ type: Types.SETBILLING, payload });
const pushtoSetBillingDetails = (payload: any) => setBillingAction(payload);
const pushtoAddBillingDetails = (payload: any) => addBillingAction(payload);
const pushSelectedBillingDataToState = (payload: any) => selectBillingAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

export const fetchBillingIdentifiersFromEpic = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server,
            log,
            agentId,
            alertnotification,
            settings:
            {
                epicendpoints: { getbillingdetails, apitoken },
                uisettings: {
                    dashboardapiconfig: {
                        getbillingdetails : getbillingdetailsApi
                    }
                },
                compatible : { consolidated_api_invocation, contact_center_type },
            }
        } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED, Types.FETCHGUARANTORDETAILS),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "getbillingDetailsEpic request", dataresponse);
                const getBillingDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    const response = server.get({
                        path: getbillingdetails + "?PatientID=" + payload?.id,
                        headers: headers
                    }).then((responsefound: any) => responsefound)
                        .catch((responseresult: any) => {
                            log.error(
                                "ccw-gadget,getbillingDetailsEpic-epic",
                                "fetch-getbillingDetails-EPIC", {
                                responseresult
                            }
                            );
                              // SEND to ALERT snotificiton/NOCserver for errors
                            if(responseresult?.status === 0) {
                                if(alertnotification?.isEnabled()){
                                    var timestamp=new Date().toJSON();
                                    alertnotification.notify({
                                        "error_code" : "930-31" ,
                                        "error_type": "SERVER_ERROR" ,
                                        "error_description": "Unable to reach active servers",
                                        "error_supertype":"SERVER_FAILS",
                                        "error_detail": "Unable to reach any of server for retring data ",
                                        "alert":"Yes",
                                        "timestamp": timestamp ,
                                        "params":responseresult
                                    });
                                }
                            }
                            let sourceerror: ErrorObject = {
                                source: "Billing",
                                type: "error",
                                status: responseresult?.status,
                                erroritems: responseresult?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return sourceerror;
                        })
                    log.debug("one-epics", "getbillingDetailsEpic response", response);
                    return from(response);
                }
                if (!getbillingdetailsApi) return []
                return getBillingDetails(dataresponse).
                pipe(
                    map(response => TransformBillingDetails(response, context, dataresponse.id))).
                pipe(
                    flatMap((response: any) => {
                        const actions: any = [
                            pushtoAddBillingDetails(response)
                        ];
                        if (response && (response.status >= 400 || response.type == "error")) {
                            actions.push(addAction(response));
                            let disp: Disposition = { value: "1007" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                disp.meta00 = agentIdValue;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta01 = dataresponse?.id;
                            disp.meta02 = response.status;
                            disp.meta03 = response.erroritems?.[0]?.error_detail;
                            disp.meta04 = 'client';
                            actions.push(pushToDisposition(disp));
                        } else {
                            let disp: Disposition = { value: "190" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                disp.meta00 = agentIdValue;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta01 = dataresponse?.id;
                            disp.meta02 = '200';
                            disp.meta03 = 'client';
                            actions.push(pushToDisposition(disp));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);



/**
 * Listen for component clear and intiate state clear for Billing
 * @param context  contains logger which is used for logging
 */
export const clearBillingEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, billing-epic",
            "clear-billing-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED,PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);